module.exports = __webpack_public_path__ + "img/SMT_40_Ms_Joyce_Choo_Hui_Lin.5a862e53.jpg";